import styled from "styled-components";

export default styled.header`
  padding: 0 10vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 75px;
`;
